/* eslint-disable @typescript-eslint/no-non-null-assertion */
import DOMPurify from 'dompurify'
import { useEffect, useRef } from 'react'

function useSanitizeHtml(): (html: string) => string {
  const purifierRef = useRef<ReturnType<DOMPurify.DOMPurify>>()

  if (!purifierRef.current) {
    purifierRef.current = DOMPurify(window)
  }

  useEffect(() => {
    const purifier = purifierRef.current!

    function beforeSanitizeAttributes(node: Element) {
      if (node.tagName === 'A' && node.hasAttribute('target')) {
        node.setAttribute('data-target', node.getAttribute('target') || '')
      }
    }

    function afterSanitizeAttributes(node: Element) {
      if (node.tagName === 'A') {
        if (node.hasAttribute('data-target')) {
          node.setAttribute('target', node.getAttribute('data-target') || '')
          node.removeAttribute('data-target')
        }
        if (node.getAttribute('target') === '_blank') {
          node.setAttribute('rel', 'noopener noreferrer')
        }
      }
    }

    purifier.addHook('beforeSanitizeAttributes', beforeSanitizeAttributes)
    purifier.addHook('afterSanitizeAttributes', afterSanitizeAttributes)

    return () => {
      purifier.removeHook('beforeSanitizeAttributes', beforeSanitizeAttributes)
      purifier.removeHook('afterSanitizeAttributes', afterSanitizeAttributes)
    }
  }, [])

  return (html: string) =>
    purifierRef.current!.sanitize(html, {
      ADD_ATTR: ['target'],
      ALLOW_DATA_ATTR: true
    })
}

export default useSanitizeHtml
